"use client"

import { BiCheckCircle } from "react-icons/bi"

export default function SuccessAlert({ message, onDismiss }) {
  if (!message) return null

  return (
    <div className="alert alert-success alert-dismissible d-flex align-items-center py-2 rounded-0" role="alert">
      <BiCheckCircle className="me-1 fs-5" />
      <div className="flex-grow-1">
        <strong>Succès !</strong> {message}
      </div>
      {onDismiss && <button type="button" className="btn-close btn-sm py-2 px-3" onClick={onDismiss} aria-label="Close"></button>}
    </div>
  )
}
